import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import LiveChat from "../components/LiveChat";
import "../App.css";
import GetQuoteButton from "../components/GetQuoteButton";
import QAChatbot from "../components/QAChatBot";
import BackToTopButton from "../components/BackToTopButton";
import ScrollSocialIcons from "../components/ScrollSocialIcons";
import NewsCarousel from "../components/NewsCarousel";
 

const newsArticles = [
  {
    id: 97,
    title: ['🇱🇰 A PROUD MILESTONE FOR CIAP! ⚓🚢✨',],
    description: [
      "We are pleased to announce that the Sri Lanka Export Development Board has appointed our Founder & Managing Director, Mr. Punsara Aravinda, to the EDB Advisory Committee on Marine-Based Industries for 2026–2029! 👏",

"This prestigious appointment recognizes his technical dedication, leadership, and vision for advancing Sri Lanka's maritime and marine engineering sectors on the global stage.",

"Congratulations, Sir, on this national honor! The entire CIAP family is proud to celebrate this achievement with you.",

"CIAP – Serves with Professionalism.",

"Navigating Excellence, Delivering Tomorrow.",
    ],
    date: "19 October 2026",
    tag: "Local",
    link: "https://www.linkedin.com/posts/ciapmarine-maritimeleadership-edbsrilanka-ugcPost-7518298941050916864-tfq7/ ",
    image: 
     require("../assets/edb-advisory.webp"),
    hashtags:
      "#CIAPMarine #MaritimeLeadership #EDBSriLanka #MarineBasedIndustries #MarineEngineering #ShipRepair #SriLankaShipping #LeadershipMilestone #ProudMoment",
  },
 {
    id: 96,
    title: ['⚓ A PROUD MILESTONE IN EXCELLENCE: LR CERTIFICATION ACHIEVED! 🚢📜✨',],
    description: [
      "We are thrilled to announce that CIAP has officially achieved Lloyd’s Register (LR) Certification!",

"This landmark achievement reflects our team’s dedication to international safety standards, precision craftsmanship, and superior engineering. With Lloyd’s Register certification, shipowners, managers, and operators can trust CIAP for class-approved afloat repairs, structural fabrication, and mechanical overhauls carried out to the highest global benchmarks.",

"A huge salute to our engineering teams and technical personnel whose hard work made this milestone possible! 👏",

"CIAP – Serves with Professionalism.",

"📲 Connect with our technical team today: ",
"📞 Speak to an Engineer: +94719 645 645",
"📧 Email: ciapinfo@theciap.com",
    ],
    date: "1 October 2026",
    tag: "Local",
    link: " ",
    image: 
     require("../assets/LR Post .webp"),
    hashtags:
      "#CIAPMarine #LloydsRegister #LRCertification #Milestone #MarineEngineering #ShipRepair #AfloatRepairs #MaritimeExcellence #CertifiedQuality #SriLankaMaritime",
  },
 {
    id: 95,
    title: ['🌱 Making a Difference for Our Shores! 🌊💙',],
    description: [
      "As part of our continuous commitment to environmental sustainability and community responsibility, the CIAP team stepped out to conduct a beach cleanup along the Uswatakeiyyawa coast.",
      "From clearing marine debris to restoring the natural shoreline, our team worked hand in hand with energy and dedication to protect our marine ecosystems. Caring for the ocean goes beyond our engineering work; it starts right here on our shores.",
    ],
    date: "29 September 2026",
    tag: "Local",
    link: " ",
    images: [
     require("../assets/BC1.webp"),
     require("../assets/BC2.webp"),
     require("../assets/BC3.webp"),
     require("../assets/BC4.webp"),
     ],
    hashtags:
      "#CIAPMarine #CSRProject #BeachCleanup #Uswatakeiyyawa #ProtectOurOceans #MarineConservation #EnvironmentalResponsibility #TeamCIAP #ServingWithProfessionalism #SriLanka",
  },
    {
    id: 94,
    title: ['Behind Every Project, Every Success and Every Milestone — there is a "Team CIAP" that makes it happen.',],
    description: [
      "This Labour Day, we celebrate our people, their commitment and the spirit that drives excellence every day.",

      "Thank you for being the Backbone of Our Journey. ⚓",
    ],
    date: "4 May 2026",
    tag: "Local",
    link: " https://www.linkedin.com/feed/update/urn:li:activity:7456913967287005184",
    image: require("../assets/workShop.webp"),   
    hashtags:
      "#CIAP #CIAPPvtLtd #teamciap #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #LabourDay #EmployeeAppreciation #CIAP #StrongerTogether",
  },
  {
    id: 93,
    title: ['Happy May Day ⚓',],
    description: [
      " Wishing strength, safety and success to every worker.",
    ],
    date: "1 May 2026",
    tag: "International",
    link: " https://www.linkedin.com/feed/update/urn:li:activity:7455865674687729664",
    image: require("../assets/mayday.webp"),   
    hashtags:
      "#CIAP #CIAPPvtLtd #teamciap #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #MayDay #CIAP #WorkersDay #WorkersRights #Solidarity #Resilience",
  },
  {
    id: 92,
    title: ['🌍World Day for Safety and Health at Work 2026',],
    description: [
      " Safety is not just a priority—it’s a culture.",
      "Let’s protect every life, every day, in every workplace.",

      "⚙️Think safe. Work safe. Stay safe.",
    ],
    date: "28 April 2026",
    tag: "International",
    link: " https://www.linkedin.com/feed/update/urn:li:activity:7455154698384265216",
    image: require("../assets/wds.webp"),
     
      
    
    hashtags:
      "#CIAP #CIAPPvtLtd #teamciap #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine",
  },
  {
    id: 91,
    title: ['Strengthening Skills, Building Excellence! 🔧🔥',],
    description: [
      " 'Team CIAP' recently conducted a Welding Training Programme for our technical team, focused on enhancing practical knowledge, safety standards and professional welding techniques.",
      "Continuous learning and hands-on training are key to delivering high-quality engineering solutions and maintaining excellence in every project we undertake.",

"CIAP, we believe investing in our people is the foundation of long-term success.",
    ],
    date: "22 April 2026",
    tag: "Local",
    link: " https://www.facebook.com/share/p/1Joiv2wFwS/",
    images: [
      require("../assets/ae.webp"),
      require("../assets/ae1.webp"),
      require("../assets/ae2.webp"),
      require("../assets/ae3.webp"),
      
    ],
    hashtags:
      "#CIAP #WeldingTraining #TechnicalExcellence #EngineeringSolutions #SkillDevelopment #ProfessionalGrowth #IndustrialTraining #TeamCIAP",
  },
  {
    id: 90,
    title: ['World Earth Day 2026 🌍💚',],
    description: [
      " “Our Power, Our Planet”",
      "Let’s work together to protect our planet, preserve our resources, and create a greener future for generations to come.",
      "Happy Earth Day!",
    ],
    date: "22 April 2026",
    tag: "Local",
    link: "",
    image: require("../assets/earthday.webp"),
    hashtags:
      "#WorldEarthDay #OurPowerOurPlanet #EarthDay2026 #Sustainability #CIAP #GreenFuture",
  },
  {
    id: 89,
    title: ['CIAP celebrated the Sinhala & Tamil New Year, and we extended our warmest wishes to everyone for a season filled with happiness, peace and prosperity. 🌞✨',],
    description: [
      " CIAP celebrated the Sinhala & Tamil New Year. We extended our warmest wishes to everyone for a season filled with happiness, peace, and prosperity. 🌞✨, gratitude, and shared success across our teams. This New Year has inspired fresh opportunities, stronger connections, and brighter moments ahead. We are proud to celebrate this joyful occasion as one Team CIAP. 🎉🌺",
    ],
    date: "20 April 2026",
    tag: "Local",
    link: " https://www.linkedin.com/feed/update/urn:li:activity:7451947967164448768",
    images: [
      require("../assets/DSCF3578.webp"),
      require("../assets/DSCF3490.webp"),
      require("../assets/DSCF3393.webp"),
      require("../assets/DSCF3427.webp"),
      require("../assets/DSCF3365.webp"),
      require("../assets/DSCF3239.webp"),
    ],
    hashtags:
      "#SinhalaTamilNewYear #HappyAurudu #NewBeginnings #Prosperity #Togetherness #CIAP #Celebration #CIAPPvtLtd #teamciap #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #newyear #EngineeringExcellence ##CIAP #CIAPPvtLtd #teamciap #CIAPMarine #ShipRepair",
  },
  {
    id: 88,
    title: ['🌸Celebrating Sinhala & Tamil New Year 🌸',
      '🌸සුභ සිංහල හා දෙමළ අලුත් අවුරුද්දක් වේවා! 🌸',
      '🌸இனிய சிங்கள & தமிழ் புத்தாண்டு நல்வாழ்த்துக்கள்! 🌸',],
    description: [
      " May this New Year bring fresh opportunities, continued growth and shared success for all.",
      'Wishing everyone a peaceful, prosperous, and fulfilling year ahead. ✨',
    ],
    date: "14 April 2026",
    tag: "International",
    link: "  https://www.facebook.com/share/p/1AoJKpnG3t/",
    image: require("../assets/aurudu.webp"),
    hashtags:
      "#CIAP #CIAPPvtLtd #teamciap #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #newyear #EngineeringExcellence ##CIAP #CIAPPvtLtd #teamciap #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #EngineeringExcellence #EasterSunday #Inspiration #Growth #TogethernessFrom #serveswithprofessionalismserveswithprofessionalism",
  },

  {
    id: 87,
    title: 'Celebrating Excellence on the Field 🇱🇰🏑',
    description: [
      " A proud moment for the nation as our Sri Lankan National Hockey Team continues to demonstrate true grit, unity, and sportsmanship. Your performance is a testament to what can be achieved through dedication and teamwork.",
      "CIAP is privileged to support and stand beside these exceptional players as they represent Sri Lanka with pride and determination. Your journey inspires not only future players but an entire nation that believes in your potential.",
      "Keep pushing boundaries and aiming higher — the journey to greatness continues! 💪🇱🇰",
    ],
    date: "13 April 2026",
    tag: "International",
    link: " https://web.facebook.com/share/p/176EqrzUMX/",
    image: require("../assets/srilankahockey.webp"),
    hashtags:
      "#CIAP #CIAPPvtLtd #teamciap #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #EngineeringExcellence ##CIAP #CIAPPvtLtd #teamciap #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #EngineeringExcellence #hockey #HockeySriLanka",
  },
  {
    id: 86,
    title: 'We’re Officially Live on Twitter! ⚓ ',
    description: [
      " Follow us as we share Insights, Updates and Innovations in 'Total Marine & Engineering Solutions'. Join us on this journey as we navigate towards the future.",
      "Link: https://x.com/CiapL47534",
      "Username:  @CiapL47534",
    ],
    date: "08 April 2026",
    tag: "International",
    link: " https://x.com/CiapL47534",
    image: require("../assets/x.webp"),
    hashtags:
      "#CIAP #CIAPPvtLtd #teamciap #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #EngineeringExcellence ##CIAP #CIAPPvtLtd #teamciap #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #twitter #EngineeringExcellence #serveswithprofessionalismserveswithprofessionalism",
  },
  {
    id: 85,
    title: 'Easter is a time of renewal, reflection and new opportunities. ',
    description: [
      " May this season inspire fresh ideas, stronger connections and continued success. ",
      "Wishing you a joyful and peaceful Easter Sunday.",
    ],
    date: "05 April 2026",
    tag: "International",
    link: " https://www.linkedin.com/feed/update/urn:li:activity:7446366438577119233",
    image: require("../assets/easter.webp"),
    hashtags:
      "#CIAP #CIAPPvtLtd #teamciap #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #EngineeringExcellence ##CIAP #CIAPPvtLtd #teamciap #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #EngineeringExcellence #EasterSunday #Inspiration #Growth #TogethernessFrom",
  },
  {
    id: 84,
    title: 'Good Friday reminds us that acts of kindness, sacrifice and understanding have a lasting impact. ',
    description: [
      " Today, let’s take a moment to appreciate the lessons of this day and channel them into creating a more compassionate, resilient and collaborative world.",
      "Wishing everyone a reflective and peaceful Good Friday. May this day inspire compassion, resilience and purpose in all that we do. ✝️💛🌿🤝✨🕊️",
    ],
    date: "03 April 2026",
    tag: "International",
    link: "  https://www.facebook.com/share/p/1Khac9K9BH/",
    image: require("../assets/goodfriday.webp"),
    hashtags:
      "#CIAP #CIAPPvtLtd #teamciap #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #goodfriday #EngineeringExcellence ##CIAP #CIAPPvtLtd #teamciap #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #EngineeringExcellence ##serveswithprofessionalism",
  },
  {
    id: 83,
    title: 'CIAP are proud to stand behind Sri Lanka Hockey National Team as they take on the international stage in Thailand.',
    description: [
      "We extend its best wishes, recognizing their dedication, teamwork and unwavering pursuit of excellence. We wish our players strength, success, and inspiring victories.",
    ],
    date: "02 April 2026",
    tag: "Local",
    link: "  https://www.facebook.com/share/p/",
    image: require("../assets/hockey26.webp"),
    hashtags:
      "#CIAP #TeamSriLanka #ProudSponsor #ExcellenceInAction #WinningSpirit #GameOn #CIAP #CIAPPvtLtd #teamciap #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #EngineeringExcellence",
  },
  {
    id: 82,
    title: '"Team CIAP " Cricket Match 🏏',
    description: [
      "More than just a game — a true display Of Teamwork, Unity, and Winning Spirit. “Team CIAP” came together with Passion, Energy and Commitment, proving that strong teams are built both on and off the field.",
      "Proud to experience the same Dedication and Collaboration that drive our success reflected in every moment of the match.",
    ],
    date: "30 March 2026",
    tag: "Local",
    link: "  https://www.facebook.com/share/p/",
    image: require("../assets/cricket26.webp"),
    hashtags:
      "#CIAP #CIAPPvtLtd #teamciap #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #EngineeringExcellence ##CIAP #CIAPPvtLtd #teamciap #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #EngineeringExcellence #serveswithprofessionalis#TeamCIAP #WinningSpirit #Teamwork #Leadership #StrongerTogether #CIAP",
  },
  {
    id: 81,
    title: '"Team CIAP" members actively participated in a valuable seminar conducted by Krishnan Subramaniam from the Institute of Chartered Shipbrokers – Sri Lanka',
    description: [
      "The session provided key insights into maritime risks and real-world challenges, which were truly appreciated by our Team CIAP.",
      "Total Marine Engineering Solutions – Delivered with Safety, Precision and Reliability..",
    ],
    date: "27 March 2026",
    tag: "Local",
    link: "  https://www.facebook.com/share/p/1Acg1RdTAP/",
    image: require("../assets/csb.webp"),
    hashtags:
      "#CIAP #CIAPPvtLtd #teamciap #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #EngineeringExcellence #serveswithprofessionalism",
  },
  {
    id: 80,
    title: "Team CIAP Eid Celebration 2026",
    description: [
      "'Team CIAP' came together to celebrate the spirit of Eid with Joy, Gratitude and Togetherness. The occasion was a great opportunity to strengthen team bonding and share moments of happiness beyond our daily work.",
      "The celebration reflects our commitment to a positive and inclusive workplace culture, built on unity, respect and collaboration. We truly value the diversity within our team and the spirit of harmony it brings to 'Team CIAP'.",
    ],
    date: "25 March 2026",
    tag: "Local",
    link: "    https://www.facebook.com/share/p/1885A2KY13/",
    image: require("../assets/eidcleb.webp"),
    hashtags:
      "#serveswithprofessionalism #CIAP #CIAPPvtLtd #teamciap #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #EngineeringExcellence #serveswithprofessionalism ",
  },
  {
    id: 79,
    title: "Eid Mubarak 2026",
    description: [
      "Wishing you Peace, Prosperity and Continued Success.",
    ],
    date: "21 March 2026",
    tag: "International",
    link: "   https://web.facebook.com/share/p/1ApC1EWe8v/",
    image: require("../assets/eid mubarak.webp"),
    hashtags:
      "#EidMubarak #Success #Prosperity #MarineEngineering #OffshoreSolutions #CareerOpportunities #IndustryCollaboration #FutureTalent #CIAP #CIAPPvtLtd #teamciap #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #EngineeringExcellence #serveswithprofessionalism ",
  },
  {
    id: 78,
    title: "When Global Shipping Faces Uncertainty, Strategic Maritime Hubs Matter",
    description: [
      "he recent Geopolitical Tensions in the Middle East are a reminder of how closely Global Trade depends on the Stability Of Key Maritime Corridors.",

      "A significant share of the World’s Energy and cargo flows through this region. When disruptions occur, the impact is felt across Shipping Routes, Supply Chains, Freight Costs and Global Markets.",
      "In such times, stable maritime hubs along major Shipping Corridors become increasingly important for supporting the continuity of global trade.",
      "Sri Lanka sits directly along one of the busiest East–West shipping lanes in the World. Thousands of vessels transit the waters just south of the island each year, connecting Asia, the Middle East, Africa, and Europe.",
      "As Global Shipping Adapts to evolving risks, ports such as Colombo and Hambantota can play a supportive role by providing reliable Maritime Services including:",

      "* Technical Support and Marine Engineering services",

      "* Bunkering and Vessel Supplies",

      "* Logistics and Transhipment Support",

      "* Crew Welfare and Operational Assistance",

      "Strengthening these capabilities does more than support Sri Lanka’s economy. It contributes to the resilience and stability of the wider Global Maritime Network.",

      "Sri Lanka has long been a trusted waypoint for international shipping. Continued investment in Maritime Infrastructure, Technical Expertise, and service reliability will further position the country as a dependable partner for the Global Shipping Community.",

      "Across the island’s Maritime Sector, industry stakeholders continue working with International Shipping Partners to support safe and efficient operations along the Indian Ocean Corridor.",

      "In an industry that connects continents, stability, preparedness and collaboration remain essential to keeping Global Trade moving forward.",
    ],
    date: "10 March 2026",
    tag: "International",
    link: "  https://www.linkedin.com/feed/update/urn:li:activity:7436720655766732800",
    image: require("../assets/mapwithship.webp"),
    hashtags:
      "#CIAP #GlobalShipping #MaritimeIndustry #EconomicResilience #SupplyChainResilience #MaritimeStrategy #GlobalTrade #IndianOcean #SriLanka #MarineEngineering #PortDevelopment #BlueEconomy #MaritimeConnectivity ",
  },
  {
    id: 77,
    title: "On International Women’s Day 2026",
    description: [
      "We Honour the Remarkable Women who continue to Break Barriers, Lead with Confidence and Inspire Innovation Across Industries. Your dedication drives progress and Empowers the Next Generation.",
    ],
    date: "8 March 2026",
    tag: "International",
    link: " https://www.linkedin.com/feed/update/urn:li:activity:7429834867208585217",
    image: require("../assets/womanday.webp"),
    hashtags:
      "#CIAP #CIAPPvtLtd #teamciap #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #EngineeringExcellence ##CIAP #CIAPPvtLtd #teamciap #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #EngineeringExcellence #womanday #serveswithprofessionalism ",
  },
  {
    id: 76,
    title: "May this Blessed Month Inspire Reflection, Unity and Renewed Purpose as we move forward into 2026 with Hope, Progress and Shared Success",
    description: [
      "Wishing you Peace, Prosperity and Strength Throughout Ramadan.",
    ],
    date: "18 February 2026",
    tag: "International",
    link: " https://www.linkedin.com/feed/update/urn:li:activity:7429834867208585217",
    image: require("../assets/ramadan.webp"),
    hashtags:
      "#CIAP #CIAPPvtLtd #teamciap  #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #EngineeringExcellence #serveswithprofessionalism #ramadankareem2026",
  },
  {
    id: 75,
    title: "As the New Lunar Year Begins, we extend our Warmest Wishes for Prosperity, Stability and Success.",
    description: [
      "May the Year of the Horse Bring Strength, Progress and New Opportunities your way. Happy Chinese New Year to you.",
    ],
    date: "17 February 2026",
    tag: "International",
    link: " https://www.linkedin.com/feed/update/urn:li:activity:7429498445867991040",
    image: require("../assets/luna.webp"),
    hashtags:
      "#CIAP #CIAPPvtLtd #teamciap #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #EngineeringExcellence #serveswithprofessionalism #chaniessnewyear2026",
  },
  {
    id: 74,
    title: "⚓✨Connecting. Collaborating. Growing",
    description: [
      "Team CIAP was proud to be part of the YoungShip Sri Lanka – 13th Annual General Meeting 2026 🌊",
      "An evening filled with meaningful conversations, industry insights and powerful networking with Sri Lanka’s Maritime Professionals. Events like these strengthen our commitment to driving innovation and excellence in the marine & shipping sector.",
      "Together, we shape the future of the maritime industry.",
    ],
    date: "15 February 2026",
    tag: "Local",
    link: " https://www.linkedin.com/feed/update/urn:li:activity:7429013283388530688",
    image: require("../assets/event-AGM.webp"),
    hashtags:
      "#CIAP #YoungShipSriLanka #MaritimeLeaders #MarineEngineering #IndustryGrowth #AGM2026 #CIAP #MarineEngineering #EngineeringExcellence #CIAP #CIAPPvtLtd #teamciap #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #EngineeringExcellence",
  },
  {
    id: 73,
    title: "Happy Valentine’s Day!!",
    description: [
      "We appreciate the strong partnerships, trust and professionalism that drive our work forward every day. Wishing our clients and partners continued success.— Team CIAP",
    ],
    date: "14 February 2026",
    tag: "International",
    link: " https://www.linkedin.com/feed/update/urn:li:activity:7428273609300832256",
    image: require("../assets/valantines.webp"),
    hashtags:
      "#CIAP #MarineEngineering #EngineeringExcellence #CIAP #CIAPPvtLtd #teamciap #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #EngineeringExcellence #valantinesday",
  },
  {
    id: 72,
    title: "TOTAL DOMINANCE!",
    description: [
      '"Team CIAP" Storms to a 5–0 WIN against Browns at the Mercantile Hockey League 2026. Power. Precision. Pride.',
    ],
    date: "09 February 2026",
    tag: "Local",
    link: "https://www.linkedin.com/feed/update/urn:li:activity:7424638431219249152",
    image: require("../assets/hockey2026.webp"),
    hashtags:
      "#MercantileHockeyLeague #MHL2026 #FieldHockey #CIAP #TEAMCIAP #CIAPHockey #BrownsHockey #HockeySriLanka #CorporateSports",
  },
  {
    id: 71,
    title:
      "On this 78th Independence Day of Sri Lanka, we honour the resilience, determination and spirit that define our nation. 🇱🇰🕊️",
    description: [
      'At CIAP, this day reminds us of our responsibility to contribute meaningfully to Sri Lanka’s progress—by building capabilities, empowering our people and delivering excellence in "Total Marine & Engineering Solutions" that strengthen the country’s Maritime Future.',
      "As a proudly Sri Lankan organisation, we remain committed to innovation, professionalism and service excellence, standing strong with the nation as we sail forward together.",
      "Happy Independence Day, Sri Lanka.",
      "Together, We Build.",
      "Together, We Progress.",
    ],
    date: "4 February 2026",
    tag: "International",
    link: "https://www.linkedin.com/feed/update/urn:li:activity:7424638431219249152",
    image: require("../assets/International day.webp"),
    hashtags:
      "#SriLankaIndependenceDay #78YearsOfIndependence #CIAP #ProudlySriLankan #MarineEngineering #NationBuilding #EngineeringExcellence #CIAP #CIAPPvtLtd #teamciap #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #EngineeringExcellence",
  },
  {
    id: 70,
    title:
      "We were pleased to welcome representatives from Yanmar Asia regional office to the CIAP Head Office for a productive and engaging discussion. ",
    description: [
      "The visit provided an excellent platform to exchange insights and explore potential areas of collaboration, as we discussed how CIAP’s Marine Engineering Capabilities can align with Yanmar’s regional presence and technology leadership to unlock future partnership opportunities.",
      "At CIAP, we value strategic relationships that are built on technical excellence, mutual trust, and a shared vision for long-term growth. We look forward to continuing these conversations and exploring pathways for collaboration in the region.  ",
      "Building partnerships.",
      "Driving engineering excellence.",
      "Creating regional impact.",
    ],
    date: "29 January 2026",
    keyParticipants: [
      {
        name: "Punsara Aravinda",
        linkedin: "https://www.linkedin.com/in/punsara-aravinda-268865130/",
      },
      {
        name: "Bhashaka Gunathilaka",
        linkedin: "https://www.linkedin.com/in/bhashaka/",
      },
      {
        name: "Chandana Rathnayake",
        linkedin: "https://www.linkedin.com/in/chandana-rathnayake-179315251/",
      },
      {
        name: "Mohamed Shehzad",
        linkedin: "https://www.linkedin.com/in/mohamed-shahzad-10b1aa67/",
      },
      {
        name: "Yanmar Marine International B.V",
        linkedin:
          "https://www.linkedin.com/company/yanmar-marine-international/",
      },
      {
        name: "Dilshan Wijerathne",
        linkedin: "https://www.linkedin.com/in/dilshan-wijerathne-7114aa191/",
      },
      {
        name: "Rakitha Hettige",
        linkedin: "https://www.linkedin.com/in/rakitha-hettige-23b1b52b2/",
      },
      {
        name: "Harshani Adisha",
        linkedin: "https://www.linkedin.com/in/harshani-adisha-26b2b5158/",
      },
      {
        name: "Madushi Rangani",
        linkedin: "https://www.linkedin.com/in/madushirangani/",
      },
      {
        name: "Ridmi Dileka",
        linkedin: "https://www.linkedin.com/in/ridmi-dileka-36430b2a5/",
      },
    ],
    tag: "Local",
    link: " https://www.linkedin.com/feed/update/urn:li:activity:7424306561294135296",
    image: require("../assets/partnership.webp"),
    hashtags:
      " #CIAP #YanmarAsia #StrategicPartnerships #MarineEngineering #TotalMarineSolutions #RegionalCollaboration #EngineeringExcellence #ServesWithProfessionalism",
  },
  {
    id: 69,
    title:
      "Team CIAP Night 2026 was successfully held on 27th January 2026, bringing the entire Team CIAP together for an evening filled with energy, celebration, and togetherness",
    description: [
      'The event beautifully reflected our strong team spirit, shared achievements, and the unity that continues to drive CIAP (PVT) LTD forward in delivering excellence in "Total Marine & Engineering Solutions"',
      'We also took a special moment to remember and appreciate our "Riding Team" members who are currently on board duty at that time and who were not partiicipate that event. whose dedication and commitment support our operations around the clock.',
    ],
    date: "1 February 2026",
    tag: "Local",
    link: "https://www.linkedin.com/feed/update/urn:li:activity:7423948608007323648",
    image: require("../assets/2026-event.webp"),
    hashtags:
      "#CIAP #CIAPPvtLtd #teamciap  #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #EngineeringExcellence #ServesWithProfessionalism",
  },
  {
    id: 68,
    title: "Happy International Education Day! ",
    description: [
      " The Power of Youth in Co-Creating Education Shapes a more Inclusive, Innovative, and Sustainable Future. ",
    ],
    date: "29 January 2026",
    tag: "International",
    link: "https://www.linkedin.com/feed/update/urn:li:activity:7420674753277009920",
    image: require("../assets/education-day.webp"),
    hashtags:
      " #CIAP #CIAPPvtLtd #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #Xmas #EngineeringExcellence #ServesWithProfessionalism #teamciap #mainoverhaul ##CIAP hashtag#CIAPPvtLtd #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #newyear2026 #EngineeringExcellence #ServesWithProfessionalism #teamciap #mainoverhaul #thaipongal",
  },
  {
    id: 67,
    title: "CIAP PVT LTD Proud to Partner with a Landmark Initiative! ",
    description: [
      " We are honored to have been associated with the first‑ever summit organized by The Management Club in Jaffna, an impactful event that opened doors to new investment opportunities and highlighted the untapped potential of the Northern Province.",
      " This summit was not only a successful gathering of leaders, innovators, and visionaries but also a true eye-opener—showcasing the immense possibilities for economic growth and regional development.",
      ' A heartfelt appreciation to "The Management Club" for this great initiative and for creating a platform that inspires collaboration, progress, and sustainable advancement.',
      "🌱 CIAP PVT LTD remains committed to supporting transformative efforts that shape Sri Lanka’s future.  ",
    ],
    date: "29 January 2026",
    keyParticipants: [
      {
        name: "Punsara Aravinda",
        linkedin: "https://www.linkedin.com/in/punsara-aravinda-268865130/",
      },
      {
        name: "Bhashaka Gunathilaka",
        linkedin: "https://www.linkedin.com/in/bhashaka/",
      },
      {
        name: "Indhra Kaushal Rajapaksa",
        linkedin:
          "https://www.linkedin.com/in/indhra-kaushal-rajapaksa-a397971b/",
      },
      {
        name: "Sunil Handunneththi",
        linkedin: "https://www.linkedin.com/in/sunil-handunneththi-4063592aa/",
      },
      {
        name: "Pradeep Saputhanthri",
        linkedin: "https://www.linkedin.com/in/pradeep-saputhanthri-7a740b24/",
      },
    ],
    tag: "Local",
    link: "https://www.linkedin.com/feed/update/urn:li:activity:7420425544980328448",
    image: require("../assets/jaffna-event.webp"),
    hashtags:
      " #NIS26 #Investment #Jaffna #SriLanka #EconomicGrowth #BusinessLeadership #CIAP #CIAPPvtLtd #teamciap #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #EngineeringExcellence #ServesWithProfessionalism #NorthernInvestmentSummit #Jaffna #Investment #EconomicDevelopment #RegionalGrowth #PublicPrivatePartnership #SriLankaInvests #TMC #TheManagementClub",
  },
  {
    id: 66,
    title: "Happy Thai Pongal! ",
    description: [
      ' Celebrating gratitude, prosperity and new beginnings. Pongalo Pongal! From "Team CIAP"  ',
    ],
    date: "15 January 2026",
    tag: "International",
    link: "https://www.linkedin.com/feed/update/urn:li:activity:7417415119221022721",
    image: require("../assets/thaipongal.webp"),
    hashtags:
      " #CIAP #CIAPPvtLtd #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #Xmas #EngineeringExcellence #ServesWithProfessionalism #teamciap #mainoverhaul ##CIAP hashtag#CIAPPvtLtd #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #newyear2026 #EngineeringExcellence #ServesWithProfessionalism #teamciap #mainoverhaul #thaipongal",
  },
  {
    id: 64,
    title: " Happy New Year 2026 from CIAP (PVT) LTD! 🚢",
    description: [
      ' 2 A New Year Brings New Opportunities and fresh Ambitions. As we step into 2026, I thank every members of the "Team CIAP "and our valued stakeholders for your Dedication and Support. Let us continue to work together with Confidence, Innovation and Unity to Achieve greater milestones ahead. Best wishes for a successful and rewarding New Year  ',
    ],
    date: "8 January 2026",
    tag: "Local",
    link: "  https://www.linkedin.com/feed/update/urn:li:activity:7414968308803751937",
    image: require("../assets/yasitha_newyear.webp"),
    hashtags:
      "#CIAP #CIAPPvtLtd #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #Xmas #EngineeringExcellence #ServesWithProfessionalism #teamciap #mainoverhaul ##CIAP #CIAPPvtLtd #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #newyear2026 #EngineeringExcellence #ServesWithProfessionalism #teamciap #mainoverhaul",
  },
  {
    id: 63,
    title: "Happy New Year 2026 from CIAP (PVT) LTD! 🚢 ",
    description: [
      " Wishing you all a Prosperous, Successful and Peaceful New Year – 2026 – From “Team CIAP” Extending our sincere Gratitude to our Clients, Partners, Principals, Associates, Stakeholders & Service Providers who have been part of “CIAP’s” journey. Looking Back at 2025 – A Year of Success & Growth with the Commitment of an Excellent & Highly Dedicated Team. Looking ahead, Promoting Sri Lanka as a Recognized Marine Services Hub, Contributing to the Nations Journey of Growth & Success. We “Team CIAP” Providing “Total Marine & Engineering Solutions” Based in Sri Lanka & Serving Globally, Specializing in Providing Riding Teams Globally.  ",
    ],
    date: "8 January 2026",
    tag: "Local",
    link: "  https://www.linkedin.com/feed/update/urn:li:activity:7414968308803751937",
    image: require("../assets/shezad_newyear.webp"),
    hashtags:
      "#CIAP #CIAPPvtLtd #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #Xmas #EngineeringExcellence #ServesWithProfessionalism #teamciap #mainoverhaul ##CIAP #CIAPPvtLtd #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #newyear2026 #EngineeringExcellence #ServesWithProfessionalism #teamciap #mainoverhaul",
  },
  {
    id: 62,
    title: "New Year. Renewed Energy. One Strong Team CIAP. 🚢🌟 ",
    description: [
      " Stepping into the New Year with Energy, Unity, and a shared passion for excellence Celebrating the moments that brought us together and the Milestones that lie ahead. Here’s to Growth, Teamwork and New Successes as One Strong “Team CIAP”  ",
    ],
    date: "7 January 2026",
    tag: "Local",
    link: "  https://www.linkedin.com/feed/update/urn:li:activity:7414888385779085312",
    image: require("../assets/newyear-ciap.webp"),
    hashtags:
      "#CIAP #CIAPPvtLtd #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #Xmas #EngineeringExcellence #ServesWithProfessionalism #teamciap #mainoverhaul ##CIAP #CIAPPvtLtd #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #newyear2026 #EngineeringExcellence #ServesWithProfessionalism #teamciap #mainoverhaul",
  },
  {
    id: 61,
    title: "Happy New Year 2026 from CIAP (PVT) LTD! 🚢 ",
    description: [
      "As a leading ship repair company in the South Asian region, we proudly look back at 2025 as a year of success and growth. Our unwavering commitment to excellence allowed us to support sea-going vessels with utmost care and precision. Partnering with world-class ship owners and managers is a testament to the quality and reliability of our services. Looking ahead, 2026 marks a fresh chapter. With a highly dedicated team, we aim to position Sri Lanka as a recognized marine services hub, contributing to the nation’s journey towards becoming a true maritime powerhouse. Many thanks to our clients, partners, and team for making this possible. We wish you safe sailing and greater achievements in the year ahead! 🌟 ",
    ],
    date: "1 January 2026",
    tag: "International",
    link: "   https://www.linkedin.com/feed/update/urn:li:activity:7413159193928454144",
    image: require("../assets/2026-new-year-punsara.webp"),
    hashtags:
      "#CIAP #CIAPPvtLtd #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #Xmas #EngineeringExcellence #ServesWithProfessionalism #teamciap #mainoverhaul ##CIAP #CIAPPvtLtd #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #newyear2026 #EngineeringExcellence #ServesWithProfessionalism #teamciap #mainoverhaul",
  },
  {
    id: 60,
    title: "Happy New Year 2026 from CIAP (PVT) LTD! 🚢 ",
    description: [
      "As we step into 2026, we extend our sincere gratitude to our clients, partners, principals, associates, and all stakeholders who have been part of CIAP’s journey. Your trust and collaboration continue to drive our commitment to engineering excellence, innovation, and sustainable growth. We look forward to strengthening partnerships, creating greater value, and navigating new opportunities together in the year ahead. Wishing you a prosperous, successful, and fulfilling New Year 2026.",
    ],
    date: "1 January 2026",
    tag: "International",
    link: "  https://www.linkedin.com/feed/update/urn:li:activity:7413445254063878144",
    image: require("../assets/2026-new-year-cfo.webp"),
    hashtags:
      "#CIAP #CIAPPvtLtd #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #Xmas #EngineeringExcellence #ServesWithProfessionalism #teamciap #mainoverhaul ##CIAP #CIAPPvtLtd #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #newyear2026 #EngineeringExcellence #ServesWithProfessionalism #teamciap #mainoverhaul ",
  },
  {
    id: 59,
    title: "Happy New Year 2026 from CIAP (PVT) LTD! 🚢 ",
    description: [
      "Team CIAP, as we drop anchor in 2025, we look ahead to a landmark year. 2026 is the year we redefine Technical Seaworthiness across the Oceans in naval terms seven seas. Every weld, every HFO system we repair and every vessel we return to the water is a testament to our precision and dedication. This year, our goal is clear: zero downtime and unmatched niche capabilities. To our engineers, our riding teams, and our partners—thank you for your grit. Let’s make 2026 our most successful voyage yet. Happy New Year to everyone",
    ],
    date: "1 January 2026",
    tag: "International",
    link: "  https://www.linkedin.com/feed/update/urn:li:activity:7413439627749056512",
    image: require("../assets/2026-new-year-coo.webp"),
    hashtags:
      "#CIAP #CIAPPvtLtd #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #Xmas #EngineeringExcellence #ServesWithProfessionalism #teamciap #mainoverhaul ##CIAP #CIAPPvtLtd #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #newyear2026 #EngineeringExcellence #ServesWithProfessionalism #teamciap #mainoverhaul",
  },

  {
    id: 58,
    title: 'Warm New Year wishes to "Team CIAP". ',
    description: [
      "May the coming Year 2026 bring New Opportunities, Strong Teamwork and Continued Success. ",
    ],
    date: "1 January 2026",
    tag: "International",
    link: "  https://www.linkedin.com/feed/update/urn:li:activity:7412200516081864704",
    image: require("../assets/2026-new year.webp"),
    hashtags:
      "#CIAP #CIAPPvtLtd #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #EngineeringExcellence #ServesWithProfessionalism #teamciap #mainoverhaul ##CIAP #CIAPPvtLtd #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #EngineeringExcellence #ServesWithProfessionalism #teamciap #mainoverhaul",
  },
  {
    id: 57,
    title: "Wishing you a Happy Qatar National Day ",
    description: [
      "May Pride, Unity, and Progress Shine Today and Always. From Team CIAP ",
    ],
    date: "18 December 2025",
    tag: "International",
    link: " https://www.linkedin.com/feed/update/urn:li:activity:7407367791181438978",
    image: require("../assets/Qatar.webp"),
    hashtags:
      "#CIAP #CIAPPvtLtd #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #EngineeringExcellence #ServesWithProfessionalism #teamciap #mainoverhaul ##CIAP #CIAPPvtLtd #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #EngineeringExcellence #ServesWithProfessionalism #teamciap #mainoverhaul",
  },
  {
    id: 56,
    title:
      "CIAP participated in the Sri Lanka Economic & Investment Summit 2025",
    description: [
      " Joining global investors, industry leaders and policymakers for critical discussions on Sri Lanka’s next phase of growth. Our focus remained clear — strengthening the country’s maritime, ship repair, and offshore services ecosystem through innovation, investment and strategic partnerships.",
      "Representing CIAP at this landmark event were:",
      "• Punsara Aravinda – Managing Director ",
      "• Bhashaka Gunathilaka – Director of Finance & Strategy",
      "• Shahzad Ghany – Head of Strategic Markets",
      "As Sri Lanka positions itself as a regional hub, CIAP continues to engage, collaborate and contribute toward shaping a competitive, future-ready Marine Sector. our focus remained clear — strengthening the country’s maritime, ship repair, and offshore services ecosystem through innovation, investment and strategic partnerships. Providing “Total Marine & Engineering Solutions",
    ],
    date: "8 December 2025",
    tag: "International",
    link: " https://www.linkedin.com/feed/update/urn:li:activity:7403655853398003712",
    image: require("../assets/investment-sumit2025.webp"),
    hashtags:
      "#SriLankaEconomicSummit #InvestmentSummit2025 #CIAP #MaritimeIndustry #ShipRepair #MarineServices #EconomicGrowth #StrategicPartnerships #SriLankaInvestments #InnovationLeadership #CoastalEconomy #IndianOceanHub #BusinessLeadership #CIAP #CIAPPvtLtd #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine",
  },
  {
    id: 55,
    title: "Happy UAE National Day! 🇦🇪",
    description: "Proud, United, and Rising Stronger Together. 🇦🇪✨",
    date: "2 December 2025",
    tag: "International",
    link: "https://www.facebook.com/share/p/17Mq5wMSZG/",
    image: require("../assets/UAE.webp"),
    hashtags:
      "#CIAP #CIAPPvtLtd #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #EngineeringExcellence #ServesWithProfessionalism #teamciap #mainoverhaul ##CIAP #CIAPPvtLtd #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #EngineeringExcellence #ServesWithProfessionalism #teamciap",
  },

  {
    id: 54,
    title: "Empowering the Next Generation! ✨",
    description:
      "CIAP PVT LTD proudly conducted a Personal Development Program at the Technical College, Maradana, inspiring students to unlock their potential and step confidently into the professional world. Our session focused on mindset building, self-awareness, communication skills, and career readiness — giving future technicians and innovators the tools they need to thrive in today’s competitive environment. We are committed to uplifting Sri Lanka’s youth by sharing industry knowledge, real-world experiences, and the right mindset for success. Together, we build skills. Together, we build the future. ",
    date: "29 November 2025",
    tag: "Local",
    link: " https://www.linkedin.com/feed/update/urn:li:activity:7399373377544736768",
    image: require("../assets/TechnicalCollege.webp"),
    hashtags:
      "# CIAP #CIAPPvtLtd #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #EngineeringExcellence #ServesWithProfessionalism #teamciap #mainoverhaul ##CIAP #CIAPPvtLtd #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #EngineeringExcellence #ServesWithProfessionalism #teamciap #mainoverhaul ##srilanakamarinesrilanakamarine #SriLankaTechnicalCollege",
  },

  {
    id: 51,
    title: "World Fisheries Day 2025",
    description: "Protect Our Oceans, sustain our future. 🌊🐟",
    date: "21 November 2025",
    tag: "International",
    link: " https://www.linkedin.com/feed/update/urn:li:activity:7397812192345014273",
    image: require("../assets/Fisheriesday.webp"),
    hashtags:
      "#CIAP #CIAPPvtLtd #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #EngineeringExcellence #ServesWithProfessionalism #teamciap #mainoverhaul #srilanakamarine #fishery",
  },
  {
    id: 50,
    title: "Every child matters. Every right counts.",
    description:
      "Let’s celebrate World Children’s Day with the spirit of inclusion for all children! ",
    date: "20 November 2025",
    tag: "International",
    link: " https://www.linkedin.com/feed/update/urn:li:activity:7397106083334582272",
    image: require("../assets/childernsday-nov.webp"),
    hashtags:
      "#CIAP #CIAPPvtLtd #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #EngineeringExcellence #ServesWithProfessionalism #teamciap #mainoverhaul #srilanakamarine #wordchildrensday #inclusionforallchildren",
  },
  {
    id: 49,
    title: "Sri Lanka’s Marine Moment Has Arrived",
    description:
      "CIAP’s Leadership Team — Punsara Aravinda and Bhashaka Gunathilaka — joined Buzi Katha on Charana TV to spotlight “The Marine Dividend” and why now is the time to Unlock Sri Lanka’s Untapped Potential in Ship Repairs, Offshore Services and Marine Engineering. From Ancient Taprobane to tomorrow’s Marine Nation — Watch the conversation that connects our past to a High-Value Maritime Future. @Punsara Aravinda Bhashaka Gunathilaka Credits to Charana TV",
    date: "15 November 2025",
    tag: "Local",
    link: " https://www.facebook.com/share/v/17j3Qyuc8Z/",
    videoUrl: "https://www.facebook.com/share/v/17j3Qyuc8Z/",
    image: require("../assets/buzi.webp"),
    hashtags:
      "#CIAP #CIAPPvtltd #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine ###EngineeringExcellence #ServesWithProfessionalism #teamciap #mainoverhaul #srilanakamarine #SteelRenewa#CIAP #CIAPPvtLtd #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #EngineeringExcellence #ServesWithProfessionalism #teamciap #mainoverhaul #srilanakamarine #SteelRenewa#srilanakamarine #Charanatv",
  },
  {
    id: 48,
    title: "Two minds. One vision.",
    description:
      "Tune in to BUZI KATHA on Charana TV, | 14 Nov 2025 | 9 AM | Featuring Mr Punsara Aravinda - Founder / Managing Director & Mr Bhashaka Gunaththilaka - Director - Finance & Strategy, Get ready for stories that spark inspiration!",
    date: "13 November 2025",
    tag: "Local",
    link: "  https://www.linkedin.com/feed/update/urn:li:activity:7394671301388505089",
    image: require("../assets/buzi.webp"),
    hashtags:
      "#CIAP #CIAPPvtLtd #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #EngineeringExcellence #ServesWithProfessionalism #teamciap #mainoverhaul #srilanakamarine",
  },
  {
    id: 47,
    title:
      "CIAP Private Limited Welcomes Rear Admiral (Rtd.) Chandana N. Rathnayake as Chief Operating Officer (COO)",
    description:
      "We are delighted to announce the appointment of Rear Admiral (Rtd.) Chandana N. Rathnayake as Chief Operating Officer (COO) of CIAP Private Limited, strengthening our leadership team as we expand our ship repair and marine engineering operations. With over 35 years of distinguished service in the Sri Lanka Navy, Rear Admiral Rathnayake has held key leadership roles across logistics, finance, procurement, and operations. His deep expertise, discipline, and strategic insight will play a pivotal role in driving CIAP’s mission to deliver world-class marine repair and maintenance solutions. He holds an MBA in Logistics Management (India), BA in Defence Studies (Sri Lanka), Postgraduate Diploma in International Relations, and has completed the Naval Staff Course (USA), Long Logistics and Management Course (India), UN Logistics Officers Course (India), and International Junior Officers’ Supply Course (UK). He is also a Chartered Member of the Chartered Institute of Logistics and Transport (Sri Lanka). We warmly welcome Rear Admiral Rathnayake to the CIAP team as he leads our next phase of growth and operational excellence.",
    date: "07 November 2025",
    tag: "Local",
    link: "  https://www.linkedin.com/feed/update/urn:li:activity:7392400742223089665",
    image: require("../assets/new coo.webp"),
    hashtags:
      "#CIAP #CIAPPvtLtd #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #EngineeringExcellence #ServesWithProfessionalism #teamciap #mainoverhaul #srilanakamarine",
  },

  {
    id: 45,
    title: "Voyage Sri Lanka 2025",
    description:
      "'Proud to be part of this inspiring event exploring Sri Lanka's Blue Economy potential. Together, We Sail Towards a Sustainable Marine Future!'",
    date: "20 October 2025",
    tag: "International | Local",
    link: "  https://www.linkedin.com/posts/ciap-pvt-ltd_ciap-ciappvtltd-ciapmarine-activity-7385946736730685440-O_eL?utm_source=share&utm_medium=member_desktop&rcm=ACoAAEWXAMEBZpzUBUnnaCalPRi3hWjv-2mzYXI",
    image: require("../assets/voyage2025.jpg"),
    hashtags:
      "#VoyageSriLanka #BlueEconomy #MarineFuture #CIAP #SriLankaMarine #Sustainability",
  },

  {
    id: 43,
    title: "Unstoppable on the Blue Turf! 🚀🏑",
    description:
      '"TEAM CIAP" proudly battled it out at the "Mercantile Hockey 9-A-Side Tournament 2025", Bringing Passion, Power and Precision to every move. From fierce tackles to lightning-fast goals, our team proved what true determination looks like! Heres to the spirit of hockey, teamwork and breaking limits together.',
    date: "1 October 2025",
    tag: "Local",
    Link: " https://www.facebook.com/share/p/1BDoBMwTga/",
    image: require("../assets/hockey.jpeg"),
  },

  {
    id: 40,
    title:
      "Team CIAP proudly celebrates World Maritime Day 2025 under the theme 'Our Ocean, Our Obligation, Our Opportunity.'🌍🚢",
    description:
      'We reaffirm our commitment to Safe, Sustainable and Innovative Maritime Solutions, Contributing to a stronger Maritime Industry in Sri Lanka. Providing "Total Marine & Engineering Solutions"',
    date: "25 September 2025",
    tag: "Local",
    Link: "https://www.linkedin.com/feed/update/urn:li:activity:7377247365981798400",
    image: require("../assets/maritme day.jpg"),
    hashtags:
      " #CIAP #CIAPPvtLtd #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #EngineeringExcellence #ServesWithProfessionalism #teamciap #mainoverhaul #srilanakamarine #MaritimeDay",
  },
  {
    id: 39,
    title: "Happy World Maritime Day! 🌍🚢",
    description:
      'Team CIAP Celebrates World Maritime Day 2025 – One Nation, One Ocean Team CIAP proudly celebrated World Maritime Day 2025, featured in Daily News, under the theme: "Our Ocean, Our Obligation, Our Opportunity." This day highlights the vital role of oceans in global trade, sustainability, and maritime innovation. The Marine Dividend: Unlocking Sri Lankas Maritime Potential. DAILYNEWS. A Final Call to Action The Marine Dividend is not a theory. It is a measurable, visible opportunity backed by data and global precedent. But it requires urgency and political will. Sri Lanka is still at the centre of global shipping. Now it must become a center of Marine Solutions. We have the location. We have a workforce. With vision and speed, we can create the infrastructure and policy framework required to lead.',
    date: "25 September 2025",
    tag: "International",
    Link: "https://www.linkedin.com/feed/update/urn:li:activity:7377247365981798400",
    image: require("../assets/artical.jpg"),
  },

  {
    id: 36,
    title: "Team CIAP at ICBT Career Day 2025",
    description:
      "We were delighted to take part in ICBT Career Day 2025, engaging with bright students and aspiring professionals. A heartfelt thank you to ICBT for allowing us to share our expertise, inspire future talent, and connect with fellow industry leaders.",
    date: "11 September 2025",
    tag: "Local",
    Link: "https://www.facebook.com/share/p/16gtyA7MAQ/",
    image: require("../assets/icbt-open-day.jpg"),
  },
  {
    id: 35,
    title: "ICBT Career Day",
    description:
      'Join Our "Growing Team". with assured Growth Providing "Total Marine & Engineering Solutions" Based in Sri Lanka, serving globally, providing "Riding teams" for any scale of ship repair worldwide',
    date: "11 September 2025, 10:00 AM",
    tag: "Local",
    Link: "https://www.facebook.com/share/p/19pMQvGixT/",
    image: require("../assets/openday_icbt.jpg"),
  },

  {
    id: 29,
    title: "National Logistics Day",
    description:
      "We proudly celebrated the vital role of shipping & logistics in keeping global trade moving.",
    date: "19 August 2025",
    tag: "Local",
    Link: "https://www.facebook.com/share/p/14GKdjUt4zU/",
    image: require("../assets/logicticday.jpg"),
    hashtags:
      "#CIAP #CIAPPvtLtd #CIAPMarine #ShipRepair #WeldingMasters #MarineFabrication #SailWithConfidence #SriLankaMarine #EngineeringExcellence #ServesWithProfessionalism #teamciap #mainoverhaul #srilanakamarine",
  },

  {
    id: 20,
    title: "CIAP CSR Project – Batawala Kanishta Vidyalaya",
    description:
      'CIAP CSR Project – Batawala Kanishta Vidyalaya On July 8th, the "Team CIAP" successfully conducted a CSR (Corporate Social Responsibility) project together with the students from the University of Moratuwa( IEEE WIE Student Branch Affinity Group) at Batawala Kanishta Vidyalaya. The initiative aimed to support and uplift the educational environment of the school. Activities included donating essential school supplies and engaging with students through interactive sessions. The project reflects "Team CIAP s" continued commitment to empowering Primary Education and fostering community development.',
    date: "24 July 2025",
    tag: "Local",
    link: "https://www.facebook.com/share/p/1ZpfH4a9Fr/",
    image: require("../assets/CIAP_csr.jpg"),
  },

  {
    id: 17,
    title: "🌍World Population Day ",
    description:
      "Every person counts. Let's build a sustainable future—together. 📈Empower, Educate, Elevate.",
    date: "July 11, 2025",
    tag: "International",
    link: "https://www.facebook.com/share/p/1DtHvXd1uU/",
    image: require("../assets/polution.jpeg"),
  },
  {
    id: 16,
    title: "🌍🔋Global Energy Independence Day",
    description:
      "Celebrating the shift to clean, reliable, and self-sufficient energy.Powering a greener, smarter future! ⚡🌱. From 'Team CIAP'",
    date: "July 10, 2025",
    tag: "International",
    link: "https://www.facebook.com/share/p/1BnuSk5JSA/",
    image: require("../assets/global_energy.jpeg"),
  },

  {
    id: 14,
    title: '"Team CIAP", Proudly Co-Sponsors the Colombo Hockey League 2025!',
    description:
      "'Team CIAP', we believe in powering more than just engineering—we power passion, performance and progress. We're proud to be a co-sponsor of the Colombo Hockey League 2025, standing side by side with athletes who embody discipline, teamwork and excellence—values that mirror our own. This partnership is more than sponsorship; it's our commitment to uplifting local talent, strengthening community spirit and supporting the next generation of champions. Here's to an exciting season of hockey. Let the games begin! #CIAP #srilanakamarine #colombohockeyleague2025 #Victory #sponsership #Hockey #WeAreCIAP #OnwardsAndUpwards #TeamCIAP",
    date: "July 4, 2025",
    link: "https://www.facebook.com/share/p/15z5TVLxN8/",
    tag: "Local",
    image: require("../assets/ciap-sponser.jpg"),
  },

  {
    id: 10,
    title:
      "CIAP Launching Globally - One Click Away from 'Total Marine & Engineering Solutions'",
    description:
      "Providing 'Total Marine & Engineering Solutions' Based in Sri Lanka, Serving Globally providing 'Ride Teams'any scale of ship repair Worldwide",
    date: "June 18, 2025",
    link: "https://www.facebook.com/share/v/1B8zuGH72x/",
    tag: "Local",
    image: require("../assets/web-lung.jpg"),
  },
  {
    id: 9,
    title: "Congratulations to the 'Team CIAP'!! 🏃‍♀️🏃‍♂️",
    description:
      '"Team CIAP" proudly participated in the Young Ship "Run for Her" Duathlon Event Sri Lanka held on 18th May 2025 at Independence Square, Colombo.Your dedication, energy and team spirit were truly inspiring. Well done on a victorious run and making us proud! 🏅👏',
    date: "May 19, 2025",
    link: "https://www.facebook.com/share/p/15nwGaWc5w/",
    tag: "Local",
    image: require("../assets/duathlon.jpg"),
  },
  {
    id: 1,
    title: "Wesak Celebration 2025",
    description:
      "Our Annual Wesak Ice Cream Dansala was held on the 9th of May in Athurugiriya for the third consecutive year",
    date: "May 10, 2025",
    link: "https://www.facebook.com/share/p/1C3YnmXcTx/",
    tag: "Local",
    image: require("../assets/dansal.jpg"),
  },
  {
    id: 2,
    title: "CIAP AURUDU UDANAYA 2025",
    description:
      '"Team CIAP" came together to celebrate the Aurudu Udanaya event on the 10th of April at Dampe Village Plilyandala, marking a joyful day filled with unity and tradition.',
    date: "April 11, 2025",
    link: "https://www.facebook.com/share/p/1YJxdV8CeB/",
    tag: "Local",
    image: require("../assets/aurudu.jpg"),
  },
  {
    id: 8,
    title: "As We Usher in the New Year of 2025",
    description:
      "We begin the year with renewed energy, enthusiasm and a strong sense of teamwork. The entire Team CIAP came together to celebrate the beginning of a promising year, marking the occasion with a special event that reflected our commitment to collaboration, growth and success.",
    date: "January 14, 2025",
    link: "https://www.facebook.com/share/p/1AMsT7UQro/",
    tag: "Local",
    image: require("../assets/pirith.jpg"),
  },
  {
    id: 3,
    title: "05th Year Anniversary Celebrations",
    description:
      'Starting with humble beginnings in December 2019, we celebrated our 5th anniversary in a very warm and engaging manner, with the participation of "Team CIAP "and family members .',
    date: "December 27, 2024",
    link: "https://www.facebook.com/share/p/1EPdPsbiAg/",
    tag: "Local",
    image: require("../assets/5years.jpg"),
  },
  {
    id: 7,
    title: "The First Marine Summit in Sri Lanka, 'VOYAGE SRI LANKA 2024'",
    description:
      "CIAP (PVT) Ltd is honored to be a 'Gold Sponsor for Voyage Sri Lanka 2024', an exceptional initiative aimed at showcasing Sri Lanka's vast potential as a strategic hub for Maritime Investments and the growing blue economy. For the first time, this landmark event brought together 20 prominent foreign investors from India, Saudi Arabia, Maldives, France, Japan, Thailand, the United States and Cambodia to explore opportunities at the Trincomalee and Hambantota ports. Investors delved into sectors such as Marina Development, Shipbuilding, Vessel Maintenance, Engineering Services, Bunkering and Offshore Services with prospects for forming joint ventures and new enterprises. We are proud to contribute to this transformative journey for Sri Lanka's Maritime Future.",
    date: "November 29, 2024",
    link: "https://www.facebook.com/share/p/1HPUezHQ3u/",
    tag: "Local",
    image: require("../assets/voyage.jpg"),
  },
  {
    id: 4,
    title:
      "A Personal and Professional Development in Marine Services Training Program ",
    description:
      "A personal and professional development in Marine Services Training Program by 'Team CIAP' was successfully held on March 23rd, 2024, at the Our  head office premises in Athurugiriya.",
    date: "March 23, 2024",
    link: "https://www.facebook.com/share/p/16bBLP4UdW/",
    tag: "Local",
    image: require("../assets/sh.jpg"),
  },
  {
    id: 5,
    title: "The Annual Cricket Tournament ",
    description:
      "The Annual Cricket Tournament by Team CIAP was successfully held on February 23rd, 2024, at the Oruwala Central School Ground.",
    date: "February 23, 2024",
    link: "https://www.facebook.com/share/p/1FcvaQYnwf/",
    tag: "Local",
    image: require("../assets/cricket1.jpg"),
  },
  {
    id: 6,
    title: "Happy holidays, Team CIAP!",
    description:
      "We've had a successful year serving our valued clients, thanks to the dedication and hard work of our team. As we cherish this moment, we wish our team and their families a joyful and well-deserved Happy Holiday!",
    date: "December 30, 2023",
    link: "https://www.facebook.com/share/p/19KNpCfxSE/",
    tag: "Local",
    image: require("../assets/holiday.jpg"),
  },
];

const News = () => {
  const [showAll, setShowAll] = useState(false);
  const initialDisplayCount = 21;

  const displayedArticles = showAll
    ? newsArticles
    : newsArticles.slice(0, initialDisplayCount);

  const hasMoreArticles = newsArticles.length > initialDisplayCount;

  return (
    <div>
      <Navbar />
      <div className="news-container">
        <h1 className="news-title">Latest News</h1>
        <div className="news-grid">
          {displayedArticles.map((article) =>
            article.video || article.videoUrl ? (
              /* VIDEO CARD SECTION */
              <div key={article.id} className="news-card-blue">
                <div className="news-card-row">
                  {article.video ? (
                    <video controls className="news-image">
                      <source src={article.video} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  ) : (
                    <div className="news-image video-container">
                      <a
                        href={article.videoUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="video-link"
                      >
                        <img src={article.image} alt={article.title} />
                        <div className="play-button-overlay">
                          <svg width="80" height="80" viewBox="0 0 80 80">
                            <circle
                              cx="40"
                              cy="40"
                              r="35"
                              fill="rgba(0,0,0,0.7)"
                            />
                            <polygon points="32,25 32,55 55,40" fill="white" />
                          </svg>
                        </div>
                        <span className="watch-on-facebook">
                          Watch on Facebook
                        </span>
                      </a>
                    </div>
                  )}
                  <div className="news-card-text">
                    <h2 className="news-card-title">{article.title}</h2>
                    <p className="news-card-date">
                      {article.date} | {article.tag}
                    </p>

                    <div className="news-card-description">
                      {Array.isArray(article.description) ? (
                        article.description.map((para, i) => (
                          <p key={i}>{para}</p>
                        ))
                      ) : (
                        <p>{article.description}</p>
                      )}
                    </div>

                    {article.keyParticipants &&
                      article.keyParticipants.length > 0 && (
                        <div
                          className="participants-section"
                          style={{ marginTop: "10px", fontSize: "0.9rem" }}
                        >
                          <strong>Username: </strong>
                          {article.keyParticipants.map((person, index) => (
                            <span key={index}>
                              <a
                                href={person.linkedin}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "#0077b5",
                                  fontWeight: "bold",
                                  textDecoration: "none",
                                }}
                              >
                                {person.name}
                              </a>
                              {index < article.keyParticipants.length - 1
                                ? ", "
                                : ""}
                            </span>
                          ))}
                        </div>
                      )}

                    <p className="news-card-hashtag">{article.hashtags}</p>
                  </div>
                </div>
              </div>
            ) : (
              /* STANDARD IMAGE CARD SECTION */
              /* We change <a> to <div> to allow multiple links inside */
              <div
                key={article.id}
                className="news-card-blue"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  const targetUrl = (article.link || article.Link || "").trim();
                  if (targetUrl) {
                    window.open(targetUrl, "_blank", "noopener,noreferrer");
                  }
                }}
              >
                <div className="news-card-row">
                  {article.images && Array.isArray(article.images) ? (
                    <NewsCarousel images={article.images} />
                  ) : (
                    <img
                      src={article.image}
                      alt={article.title}
                      className="news-image"
                    />
                  )}
                  <div className="news-card-text">
                    <h2 className="news-card-title">{article.title}</h2>
                    <p className="news-card-date">
                      {article.date} | {article.tag}
                    </p>

                    <div className="news-card-description">
                      {Array.isArray(article.description) ? (
                        article.description.map((para, i) => (
                          <p key={i}>{para}</p>
                        ))
                      ) : (
                        <p>{article.description}</p>
                      )}
                    </div>

                    {/* Individual LinkedIn Links now work because of e.stopPropagation() */}
                    {article.keyParticipants &&
                      article.keyParticipants.length > 0 && (
                        <div
                          className="participants-section"
                          style={{ marginTop: "10px", fontSize: "0.9rem" }}
                        >
                          <strong>Key Participants: </strong>
                          {article.keyParticipants.map((person, index) => (
                            <span key={index}>
                              <a
                                href={person.linkedin}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={(e) =>
                                  e.stopPropagation()
                                } /* This stops the main card link from opening */
                              >
                                {person.name}
                              </a>
                              {index < article.keyParticipants.length - 1
                                ? ", "
                                : ""}
                            </span>
                          ))}
                        </div>
                      )}

                    <p className="news-card-hashtag">{article.hashtags}</p>
                  </div>
                </div>
              </div>
            ),
          )}
        </div>

        {hasMoreArticles && (
          <div className="view-more-container">
            <button
              className="view-more-btn"
              onClick={() => setShowAll(!showAll)}
            >
              {showAll
                ? "Show Less"
                : `View More (${newsArticles.length - initialDisplayCount} more)`}
            </button>
          </div>
        )}
      </div>
      <LiveChat />
      <QAChatbot />
      <ScrollSocialIcons />
      <GetQuoteButton />
      <BackToTopButton />
      <Footer />
    </div>
  );
};
export default News;
